/* TIMESTAMP START 2026-08-22T13:18:15-04:00 | REVISION R000228 | Draft sync of tested cart packing bundle */
/* TIMESTAMP START 2026-08-21T16:53:44-04:00 | REVISION R000190 */
(() => {
  'use strict';

  const PACKING_VALUES = ['BULK', 'INDIVIDUAL'];
  /* TIMESTAMP START 2026-08-21T17:46:19-04:00 | REVISION R000196 */
  // Packing support is determined by the validated line property and values, not a product allowlist.
  /* TIMESTAMP END 2026-08-21T17:46:19-04:00 | REVISION R000196 */
  const SUCCESS_FOCUS_KEY = 'jpi-cart-packing-success';
  const PACKING_COPY = {
    BULK: 'Packed together',
    INDIVIDUAL: 'Packed separately',
  };
  let cartMutationInFlight = false;
  let nativeMutationPendingUntil = 0;

  const normalizePropertyName = (value) => value.replace(/[:\s]+/g, '').toLowerCase();

  const cartEndpoint = (path) => {
    const configuredRoot = window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : '/';
    const root = configuredRoot && configuredRoot.endsWith('/')
      ? configuredRoot
      : `${configuredRoot || '/'}${configuredRoot ? '/' : ''}`;

    return `${root}${path}`;
  };

  const responseJson = async (response) => {
    try {
      return await response.json();
    } catch (error) {
      return {};
    }
  };

  const responseError = (payload, fallback) => (
    payload && (payload.description || payload.message)
      ? payload.description || payload.message
      : fallback
  );

  const setCartLocked = (isLocked) => {
    const cartRoot = document.getElementById('main-cart-items');
    const footerRoot = document.getElementById('main-cart-footer');
    const controls = [
      ...document.querySelectorAll(
        '#main-cart-items .quantity__button, '
        + '#main-cart-items .quantity__input, '
        + '#main-cart-items cart-remove-button a, '
        + '#main-cart-items .jpi-packaging-choice__input, '
        + '#main-cart-footer button, '
        + '#main-cart-footer input, '
        + '#main-cart-footer a[href]',
      ),
    ];

    [cartRoot, footerRoot].filter(Boolean).forEach((root) => {
      root.classList.toggle('cart__items--disabled', isLocked);
      root.toggleAttribute('aria-busy', isLocked);
    });

    controls.forEach((control) => {
      if (isLocked) {
        if (control.dataset.jpiCartLock === 'true') return;
        control.dataset.jpiCartLock = 'true';
        control.dataset.jpiCartLockDisabled = 'disabled' in control
          ? String(control.disabled)
          : 'unsupported';
        control.dataset.jpiCartLockAriaDisabled = control.hasAttribute('aria-disabled')
          ? control.getAttribute('aria-disabled')
          : '__missing__';
        control.dataset.jpiCartLockTabindex = control.hasAttribute('tabindex')
          ? control.getAttribute('tabindex')
          : '__missing__';

        if ('disabled' in control) control.disabled = true;
        control.setAttribute('aria-disabled', 'true');
        if (control.matches('a')) control.setAttribute('tabindex', '-1');
        return;
      }

      if (control.dataset.jpiCartLock !== 'true') return;
      if ('disabled' in control && control.dataset.jpiCartLockDisabled !== 'unsupported') {
        control.disabled = control.dataset.jpiCartLockDisabled === 'true';
      }
      if (control.dataset.jpiCartLockAriaDisabled === '__missing__') {
        control.removeAttribute('aria-disabled');
      } else {
        control.setAttribute('aria-disabled', control.dataset.jpiCartLockAriaDisabled);
      }
      if (control.dataset.jpiCartLockTabindex === '__missing__') {
        control.removeAttribute('tabindex');
      } else {
        control.setAttribute('tabindex', control.dataset.jpiCartLockTabindex);
      }
      delete control.dataset.jpiCartLock;
      delete control.dataset.jpiCartLockDisabled;
      delete control.dataset.jpiCartLockAriaDisabled;
      delete control.dataset.jpiCartLockTabindex;
    });
  };

  const rememberSuccessfulUpdate = (record) => {
    try {
      window.sessionStorage.setItem(SUCCESS_FOCUS_KEY, JSON.stringify(record));
    } catch (error) {
      // The update remains valid when session storage is unavailable.
    }
  };

  const restoreSuccessfulUpdate = () => {
    let record = null;
    try {
      record = JSON.parse(window.sessionStorage.getItem(SUCCESS_FOCUS_KEY) || 'null');
      window.sessionStorage.removeItem(SUCCESS_FOCUS_KEY);
    } catch (error) {
      return;
    }
    if (!record) return;

    const fieldsets = Array.from(document.querySelectorAll('.jpi-cart-packaging-choice'));
    const fieldset = fieldsets.find((candidate) => (
      record.lineKey && candidate.dataset.lineKey === record.lineKey
    )) || fieldsets.find((candidate) => (
      candidate.dataset.variantId === String(record.variantId)
      && candidate.dataset.currentValue === record.value
    ));
    if (!fieldset) return;

    const selectedInput = Array.from(fieldset.querySelectorAll('.jpi-packaging-choice__input'))
      .find((input) => input.value === record.value);
    const status = fieldset.querySelector('.jpi-cart-packaging-choice__message');
    if (status) {
      const label = record.value === 'BULK' ? 'Bulk' : 'Individual';
      status.textContent = `Packing updated to ${label}.`;
    }
    if (selectedInput) {
      window.requestAnimationFrame(() => selectedInput.focus({ preventScroll: true }));
    }
  };

  const makeDot = () => {
    const dot = document.createElement('span');
    dot.className = 'jpi-packaging-choice__dot';
    dot.setAttribute('aria-hidden', 'true');
    return dot;
  };

  const makePackingIcon = (value) => {
    const icon = document.createElement('span');
    icon.className = 'jpi-packaging-choice__icon';
    icon.setAttribute('aria-hidden', 'true');

    if (value === 'BULK') {
      const ring = document.createElement('span');
      ring.className = 'jpi-packaging-choice__bulk-ring';
      ring.append(makeDot(), makeDot(), makeDot());
      icon.append(ring);
      return icon;
    }

    const rings = document.createElement('span');
    rings.className = 'jpi-packaging-choice__individual-rings';
    for (let index = 0; index < 3; index += 1) {
      const ring = document.createElement('span');
      ring.className = 'jpi-packaging-choice__unit-ring';
      ring.append(makeDot());
      rings.append(ring);
    }
    icon.append(rings);
    return icon;
  };

  const setSelectedCard = (fieldset, value) => {
    fieldset.querySelectorAll('.jpi-packaging-choice__card').forEach((card) => {
      const input = card.querySelector('.jpi-packaging-choice__input');
      const isSelected = Boolean(input && input.value === value);
      card.dataset.selected = String(isSelected);
      if (input) input.checked = isSelected;
    });
  };

  const setBusy = (fieldset, isBusy) => {
    fieldset.toggleAttribute('aria-busy', isBusy);
    fieldset.dataset.updating = String(isBusy);
    fieldset.querySelectorAll('.jpi-packaging-choice__input').forEach((input) => {
      input.disabled = isBusy;
    });
  };

  const updatePacking = async (fieldset, nextValue) => {
    const originalValue = fieldset.dataset.currentValue;
    const status = fieldset.querySelector('.jpi-cart-packaging-choice__message');
    const cartRoot = document.getElementById('main-cart-items');
    const nativeMutationIsActive = Boolean(
      cartRoot
      && (
        cartRoot.classList.contains('cart__items--disabled')
        || window.performance.now() < nativeMutationPendingUntil
      )
    );

    if (cartMutationInFlight || nativeMutationIsActive) {
      setSelectedCard(fieldset, originalValue);
      status.classList.remove('jpi-cart-packaging-choice__message--error');
      status.textContent = 'Wait for the current cart update, then try again.';
      const originalInput = Array.from(fieldset.querySelectorAll('.jpi-packaging-choice__input'))
        .find((input) => input.value === originalValue);
      if (originalInput) window.requestAnimationFrame(() => originalInput.focus());
      return;
    }

    cartMutationInFlight = true;
    setCartLocked(true);
    setBusy(fieldset, true);
    status.classList.remove('jpi-cart-packaging-choice__message--error');
    status.textContent = 'Updating packing…';

    try {
      const cartResponse = await fetch(cartEndpoint('cart.js'), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      const cart = await responseJson(cartResponse);
      if (!cartResponse.ok) {
        throw new Error(responseError(cart, 'The cart could not be loaded.'));
      }

      const item = Array.isArray(cart.items)
        ? cart.items.find((cartItem) => cartItem.key === fieldset.dataset.lineKey)
        : null;
      if (!item) {
        throw new Error('This cart item changed. Refresh the page and try again.');
      }

      const properties = { ...(item.properties || {}) };
      /* TIMESTAMP START 2026-08-21T17:17:18-04:00 | REVISION R000193 */
      const requestedPropertyKey = fieldset.dataset.propertyKey;
      const propertyKey = requestedPropertyKey
        && Object.prototype.hasOwnProperty.call(properties, requestedPropertyKey)
        ? requestedPropertyKey
        : Object.prototype.hasOwnProperty.call(properties, 'Packing')
          ? 'Packing'
          : Object.prototype.hasOwnProperty.call(properties, 'Packing:')
            ? 'Packing:'
            : null;
      /* TIMESTAMP END 2026-08-21T17:17:18-04:00 | REVISION R000193 */
      if (!propertyKey) {
        throw new Error('The packing selection is no longer available for this item.');
      }
      properties[propertyKey] = nextValue;

      const changeResponse = await fetch(cartEndpoint('cart/change.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: item.key,
          properties,
        }),
      });
      const changedCart = await responseJson(changeResponse);
      if (!changeResponse.ok) {
        throw new Error(responseError(changedCart, 'Packing could not be updated.'));
      }

      fieldset.dataset.currentValue = nextValue;
      status.textContent = 'Packing updated. Refreshing cart…';
      const updatedItem = Array.isArray(changedCart.items)
        ? changedCart.items.find((candidate) => {
          const candidateProperties = candidate.properties || {};
          const propertyKeys = Object.keys(properties);
          return String(candidate.variant_id) === fieldset.dataset.variantId
            && Object.keys(candidateProperties).length === propertyKeys.length
            && propertyKeys.every((key) => candidateProperties[key] === properties[key]);
        })
        : null;
      rememberSuccessfulUpdate({
        lineKey: updatedItem ? updatedItem.key : null,
        variantId: fieldset.dataset.variantId,
        value: nextValue,
      });
      window.location.reload();
    } catch (error) {
      setSelectedCard(fieldset, originalValue);
      setBusy(fieldset, false);
      setCartLocked(false);
      cartMutationInFlight = false;
      status.classList.add('jpi-cart-packaging-choice__message--error');
      status.textContent = error instanceof Error
        ? error.message
        : 'Packing could not be updated. Please try again.';
      const originalInput = Array.from(fieldset.querySelectorAll('.jpi-packaging-choice__input'))
        .find((input) => input.value === originalValue);
      if (originalInput) window.requestAnimationFrame(() => originalInput.focus());
    }
  };

  /* TIMESTAMP START 2026-08-21T17:17:18-04:00 | REVISION R000193 */
  const bindPackingFieldset = (fieldset) => {
    if (fieldset.dataset.jpiCartPackagingBound === 'true') return;
    fieldset.dataset.jpiCartPackagingBound = 'true';

    fieldset.addEventListener('change', (event) => {
      event.stopPropagation();
      const input = event.target.closest('.jpi-packaging-choice__input');
      if (!input || !fieldset.contains(input) || input.value === fieldset.dataset.currentValue) return;
      setSelectedCard(fieldset, input.value);
      updatePacking(fieldset, input.value);
    });
  };
  /* TIMESTAMP END 2026-08-21T17:17:18-04:00 | REVISION R000193 */

  const makeChoice = (fieldset, value, groupName, idBase) => {
    const card = document.createElement('label');
    card.className = 'jpi-packaging-choice__card';
    card.dataset.selected = String(value === fieldset.dataset.currentValue);

    const input = document.createElement('input');
    input.className = 'jpi-packaging-choice__input';
    input.type = 'radio';
    input.name = groupName;
    input.id = `${idBase}-${value.toLowerCase()}`;
    input.value = value;
    input.checked = value === fieldset.dataset.currentValue;

    const copy = document.createElement('span');
    copy.className = 'jpi-packaging-choice__copy';

    const name = document.createElement('span');
    name.className = 'jpi-packaging-choice__name';
    name.textContent = value === 'BULK' ? 'Bulk' : 'Individual';

    const description = document.createElement('span');
    description.className = 'jpi-packaging-choice__description';
    description.textContent = PACKING_COPY[value];

    const indicator = document.createElement('span');
    indicator.className = 'jpi-packaging-choice__status';
    indicator.setAttribute('aria-hidden', 'true');

    copy.append(name, description);
    card.append(input, makePackingIcon(value), copy, indicator);
    return card;
  };

  const enhancePackingRow = (propertyRow, index) => {
    if (propertyRow.dataset.jpiCartPackaging === 'true') return;

    const term = propertyRow.querySelector('dt');
    const valueNode = propertyRow.querySelector('dd');
    const cartItem = propertyRow.closest('.cart-item');
    const quantityInput = cartItem && cartItem.querySelector('input[data-quantity-line-key]');
    const currentValue = valueNode ? valueNode.textContent.trim().toUpperCase() : '';

    /* TIMESTAMP START 2026-08-21T17:46:19-04:00 | REVISION R000196 */
    if (
      !term
      || !valueNode
      || !cartItem
      || !quantityInput
      || !PACKING_VALUES.includes(currentValue)
    ) {
      return;
    }
    /* TIMESTAMP END 2026-08-21T17:46:19-04:00 | REVISION R000196 */

    const lineKey = quantityInput.dataset.quantityLineKey;
    const safeId = `${cartItem.id || `item-${index}`}`.replace(/[^a-z0-9_-]/gi, '-');
    const idBase = `jpi-cart-packing-${safeId}`;
    const productName = cartItem.querySelector('.cart-item__name')?.textContent.trim() || 'this item';

    propertyRow.dataset.jpiCartPackaging = 'true';
    propertyRow.classList.add('jpi-cart-packaging-row');
    term.textContent = 'Packing:';

    const fieldset = document.createElement('fieldset');
    fieldset.className = 'jpi-packaging-choice jpi-cart-packaging-choice';
    fieldset.dataset.currentValue = currentValue;
    fieldset.dataset.lineKey = lineKey;
    fieldset.dataset.variantId = quantityInput.dataset.quantityVariantId;
    fieldset.dataset.updating = 'false';

    const legend = document.createElement('legend');
    legend.className = 'visually-hidden';
    legend.textContent = `Choose packing for ${productName}`;

    const cards = document.createElement('span');
    cards.className = 'jpi-packaging-choice__cards';
    const groupName = `jpi-cart-packing-${index}`;
    PACKING_VALUES.forEach((value) => {
      cards.append(makeChoice(fieldset, value, groupName, idBase));
    });

    const status = document.createElement('span');
    status.className = 'jpi-cart-packaging-choice__message';
    status.id = `${idBase}-message`;
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    fieldset.setAttribute('aria-describedby', status.id);

    fieldset.append(legend, cards, status);
    valueNode.replaceChildren(fieldset);
    /* TIMESTAMP START 2026-08-21T17:17:18-04:00 | REVISION R000193 */
    bindPackingFieldset(fieldset);
    /* TIMESTAMP END 2026-08-21T17:17:18-04:00 | REVISION R000193 */
  };

  const enhanceCart = () => {
    const cartRoot = document.getElementById('main-cart-items');
    if (!cartRoot) return;

    /* TIMESTAMP START 2026-08-21T17:17:18-04:00 | REVISION R000193 */
    cartRoot.querySelectorAll('.jpi-cart-packaging-choice').forEach(bindPackingFieldset);
    /* TIMESTAMP END 2026-08-21T17:17:18-04:00 | REVISION R000193 */

    const packingRows = Array.from(cartRoot.querySelectorAll('.cart-item__details dl .product-option'))
      .filter((row) => {
        const term = row.querySelector('dt');
        return term && normalizePropertyName(term.textContent) === 'packing';
      });
    packingRows.forEach(enhancePackingRow);
  };

  const start = () => {
    const cartRoot = document.getElementById('main-cart-items');
    if (!cartRoot) return;

    let frameId = 0;
    const scheduleEnhancement = () => {
      window.cancelAnimationFrame(frameId);
      frameId = window.requestAnimationFrame(enhanceCart);
    };

    cartRoot.addEventListener('change', (event) => {
      if (event.target.matches('.quantity__input')) {
        nativeMutationPendingUntil = window.performance.now() + 1200;
      }
    }, true);
    cartRoot.addEventListener('click', (event) => {
      if (event.target.closest('.quantity__button, cart-remove-button')) {
        nativeMutationPendingUntil = window.performance.now() + 1200;
      }
    }, true);

    enhanceCart();
    restoreSuccessfulUpdate();
    const observer = new MutationObserver(scheduleEnhancement);
    observer.observe(cartRoot, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
/* TIMESTAMP END 2026-08-21T16:53:44-04:00 | REVISION R000190 */
/* TIMESTAMP END 2026-08-22T13:18:15-04:00 | REVISION R000228 | Draft sync of tested cart packing bundle */

